import React from "react";
import { formatDate } from "../../utils/helps";
import { Link } from "react-router-dom";
const ArticleCard = ({ article }) => {
  console.log("article", article?.images[0]?.url);
  return (
    <div className="card bg-base-100 shadow-xl mb-2">
      <figure className="relative aspect-[3/2] ">
        <img
          src={`${process.env.REACT_APP_API_URL}media/${article?.images[0]?.url}`}
          alt={article?.title}
          className="w-full h-full object-cover"
        />
      </figure>
      <div className="card-body p-[8px] h-[150px]">
        <Link to={`/post/${article?.slug}`}>
          <h3
            className="card-title text-sm overflow-hidden text-ellipsis text-justify"
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            {article?.title}
          </h3>
        </Link>

        <p className="text-xs text-gray-500 italic">
          {formatDate(article?.updatedAt)}
        </p>
      </div>
    </div>
  );
};

export default ArticleCard;
